import { render } from "@wordpress/element";
import DiscountNotice from './components/discount-notice';

render(
    <DiscountNotice />,
    document.getElementById( "omnisend-hostinger-discount-notice" ),
);
